import { FaListUl } from 'react-icons/fa';
import React, { Component } from 'react';


class CustomData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            filterBy: {},
            sortBy: 'DisplayName',
            sortOrder: 1,
            loading: false,
            type: "special"
        };
    }
    cancel = () => {
        this.setState({ editData: false, tempData: false, loading: false, error: '' })
    }
    editData = (id) => e => {
        var item = this.props.data.CustomData.data.find(function (element) {
            return element.id === id;
        });
        this.setState({ editData: true, tempData: item, loading: false, error: '' })
    }
    // add = () => {
    //     this.setState({ editData: true, promptID: null, loading: false, error: '' })
    // }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    toggle = (param) => (e) => {
        var newState = Object.assign({}, this.state)
        newState[param] = this.state[param] ? false : true
        this.setState(newState)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }
    handleTempDataValueChange = (e, index) => {
        const newValue = e.target.value;

        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            if (Array.isArray(updatedTempData.value)) {
                updatedTempData.value[index] = newValue;
            } else {
                updatedTempData.value = newValue;
            }
            return { tempData: updatedTempData };
        });
    }
    toggleTempDataValue = (e) => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = !updatedTempData.value;
            return { tempData: updatedTempData };
        })
    }

    confirmEdit = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempData = this.state.tempData
        tempData.creationDate = new Date().toJSON()
        this.props.ws.send(JSON.stringify({ route: 'updateCustomData', data: tempData }))
        //update state to not be editing
        this.setState({ editData: false, loading: false, tempData: null })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    checkType = (e) => {
        console.log(e.target.value)
        this.setState({ type: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })

    }

    render() {
        if (this.props.active) {
            // if (this.state.type === "" || this.state.type === undefined) {
            //     this.setState({ type: "user" })
            // }


            var dataList = []
            var CustomData = JSON.parse(JSON.stringify(this.props.data.CustomData.data));
            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                CustomData = this.filterFunc(CustomData, this.state.filterBy)
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                CustomData.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            for (var data of CustomData) {


                dataList.push(
                    <tr className="dataRow" onClick={this.editData(data.id)} key={prompt.id}>
                        <td style={{ flex: '1 0 270px', textAlign: 'left' }}>{data.name}</td>
                        <td style={{ flex: '0 0 150px', textAlign: 'left' }}>
                            {Array.isArray(data.value) ? <FaListUl style={{ marginRight: '5px' }} /> : ''}
                            {(Array.isArray(data.value) ? "" : data.value)}
                            {typeof data.value === 'boolean' ? (data.value ? "Active" : "Inactive") : ""}
                        </td>
                        <td style={{ flex: '0 0 200px', textAlign: 'left' }}>{data.lastUpdatedUser}</td>
                        <td style={{ flex: '0 0 200px', textAlign: 'right' }}>{data.lastUpdatedDate}</td>
                    </tr>
                );

            }

            var editData = "";
            if (this.state.editData) {
                let inputElements = null;
                if (Array.isArray(this.state.tempData.value)) {
                    inputElements = this.state.tempData.value.map((item, index) => (
                        <input
                            key={index}
                            type="text"
                            value={item}
                            onChange={(e) => this.handleTempDataValueChange(e, index)}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                        />
                    ));

                    // Add an empty input box with the ref
                    inputElements.push(
                        <input
                            key={inputElements.length}
                            type="text"
                            value=""
                            onChange={(e) => this.handleTempDataValueChange(e, this.state.tempData.value.length)}
                            ref={this.newInput} // Save a reference to the input element
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                        />
                    );
                } else if (typeof this.state.tempData.value === 'boolean') {
                    inputElements = (
                        <select
                            value={this.state.tempData.value}
                            onChange={this.toggleTempDataValue}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                        >
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>
                        </select>
                    );
                } else {
                    if (this.state.tempData.options != undefined) {
                        //Build out options for dropdown
                        var options = []
                        for (var option of this.state.tempData.options) {
                            options.push(<option value={option}>{option}</option>)
                        }

                        inputElements = (
                            <select
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            >
                                {options}
                            </select>
                        );
                    } else {
                        inputElements = (
                            <input
                                type="text"
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            />
                        );
                    }
                }
                editData = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div className="error">{this.state.error}</div>

                            {/* Display the current tempData Name */}
                            <h2 style={{ marginBottom: '10px', fontSize: '1.5rem' }}>{this.state.tempData.name}</h2>

                            {/* Edit box for the value */}
                            {inputElements}

                            {/* Confirm button */}
                            <button className="button" onClick={this.confirmEdit} style={{ border: 'none', cursor: 'pointer' }}>
                                Confirm
                            </button>
                        </div>
                    </div>
                );
            }











            return (
                <div width="100%">
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '200px', marginRight: '10px', marginTop: '2px' }}>
                            <div className="filterBox" style={{
                                "width": "210px"
                            }}>

                                <h4>Filter By:</h4>
                                <div style={{ width: '150px' }}>
                                    <label>Name:</label>
                                    <input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
                                </div>
                                <div style={{ width: '150px' }}>
                                    <label>User:   </label>
                                    <input type="text" onChange={this.filter("lastUpdatedUser")} value={this.state.filterBy.User} />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ float: "right" }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ minWidth: '260px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                                        <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("value")}>Value {this.filterIcon("value")}</th>
                                        <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("lastUpdatedUser")}>Last Updated User {this.filterIcon("lastUpdatedUser")}</th>
                                        <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastUpdatedDate")}>Last Updated {this.filterIcon("lastUpdatedDate")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editData}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}


const icon = "menuWorkflow"
const roles = ["View"]
export { CustomData, icon, roles }